module.exports = __webpack_public_path__ + "static/img/11.d6bb5b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/eng/11.png
// module id = Dicv
// module chunks = 0